import React, { FC } from "react";
import { Button, Stack, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSxMerge } from "shared-ts-mui";
import { useLocation, useNavigate } from "@tanstack/react-router";

export interface NotFoundComponentProps {
  sx?: SxProps;
}

export const NotFoundComponent: FC<NotFoundComponentProps> = (props) => {
  const { t } = useTranslation("shared-ts-router");
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const sx = useSxMerge(
    {
      flexGrow: 1,
      minWidth: 0,
      minHeight: 0,
      width: "100%",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    props.sx
  );
  const handleGotoFrontpage = () => {
    navigate({ to: "/" });
  };

  return (
    <Stack sx={sx}>
      <Typography>{t("Page Not Found")}:</Typography>
      <Typography>{pathname}</Typography>
      <Button
        onClick={handleGotoFrontpage}
        variant={"contained"}
        sx={{ mt: 2 }}
      >
        {t("Goto Frontpage")}
      </Button>
    </Stack>
  );
};
